module.exports = __webpack_public_path__ + "assets/gpay.e90384d9d0103a6527aa10069db377d7.svg";